/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Keen_Heron_BoltInputs */

const en_soft_keen_heron_bolt = /** @type {(inputs: Soft_Keen_Heron_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User ID`)
};

const de_soft_keen_heron_bolt = /** @type {(inputs: Soft_Keen_Heron_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer-ID`)
};

/**
* | output |
* | --- |
* | "User ID" |
*
* @param {Soft_Keen_Heron_BoltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_keen_heron_bolt = /** @type {((inputs?: Soft_Keen_Heron_BoltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Keen_Heron_BoltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_keen_heron_bolt(inputs)
	return de_soft_keen_heron_bolt(inputs)
});